module.exports = "/assets/c5049810418301e4fda56777fa10e349.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_desktop.png
// module id = 479
// module chunks = 0